/* A class that renders a dynamic object by its Y-coordinate.
 The object's depth will be calculated every pre-render of the 
 parent scene. For objects that can't move, use StaticSortByY
 instead. */
export default class DynamicSortByY {
  renderer:
    | Phaser.GameObjects.Sprite
    | Phaser.GameObjects.Image
    | Phaser.GameObjects.Container;

  constructor(
    renderer:
      | Phaser.GameObjects.Sprite
      | Phaser.GameObjects.Image
      | Phaser.GameObjects.Container,
    scene: Phaser.Scene,
  ) {
    this.renderer = renderer;

    // Calculate once at initialization.
    renderer.setDepth(
      this.getYFromDepth(renderer.getWorldTransformMatrix().ty),
    );

    scene.events.on('prerender', () => {
      this.update();
    });
  }

  getYFromDepth(depth: number) {
    return depth;
  }

  update() {
    this.renderer.setDepth(
      this.getYFromDepth(this.renderer.getWorldTransformMatrix().ty),
    );
  }
}
